import React from "react"

export const PlusIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 33C8.16267 33 1 25.8373 1 17C1 8.16267 8.16267 1 17 1C25.8373 1 33 8.16267 33 17C33 25.8373 25.8373 33 17 33Z"
      fill="black"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M17 10V24V10Z" fill="black" />
    <path
      d="M17 10V24"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M24 17H10H24Z" fill="black" />
    <path
      d="M24 17H10"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
